import React from "react";

/**
 * Renders a pencil icon as an SVG component.
 *
 * @param {object} cls - The class name for styling the SVG component.
 * @return {JSX} The pencil icon SVG component.
 */
export const PencilIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      className={cls}
    >
      <g clipPath="url(#clip0_2105_25788)">
        <path
          d="M11.371 0.703266C10.9175 0.24975 10.3146 0 9.67325 0C9.03193 0 8.42898 0.24975 7.97549 0.703242L1.26545 7.4133C1.20835 7.4704 1.16699 7.54127 1.14533 7.61906L0.0913925 11.4056C0.0459472 11.5689 0.0921894 11.744 0.2124 11.8636C0.301463 11.9522 0.420807 12 0.54301 12C0.585713 12 0.628791 11.9941 0.671049 11.9821L4.45754 10.9066C4.61729 10.8612 4.74113 10.7347 4.78304 10.5739C4.82495 10.4132 4.77868 10.2424 4.66142 10.1247L2.27427 7.73032L7.83634 2.16823L9.90488 4.23677L5.6469 8.48316C5.4636 8.66597 5.4632 8.96276 5.64601 9.14606C5.8288 9.32939 6.12564 9.32977 6.30892 9.14698L11.3709 4.09873C11.8245 3.64523 12.0742 3.0423 12.0742 2.40098C12.0742 1.75966 11.8245 1.15673 11.371 0.703266ZM3.43503 10.2225L1.2186 10.852L1.83934 8.62191L3.43503 10.2225ZM10.7085 3.43535L10.5687 3.57478L8.49927 1.50532L8.63844 1.36615C8.91484 1.08973 9.28234 0.9375 9.67325 0.9375C10.0642 0.9375 10.4316 1.08973 10.7081 1.36617C10.9845 1.64257 11.1367 2.01007 11.1367 2.40098C11.1367 2.7919 10.9845 3.1594 10.7085 3.43535Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2105_25788">
          <rect
            width="12"
            height="12"
            fill="currentColor"
            transform="translate(0.0742188)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
